import { StyledCategoryCard } from './style';
import { CategoryData } from 'types/CategoryData';
import { useIntl } from 'react-intl';
import { FallbackImage } from '../UploadImage/fallBack/FallBackImage';
import { useNavigate } from 'react-router-dom';
import PublicRoute from 'enums/publicRoutes';
import useScroll from '../../utils/useScroll';

export interface CategoryCardProps {
  bordered?: boolean;
  hoverable?: boolean;
  category?: CategoryData;
  img?: string;
  imageUrl?: string;
}

interface CategoryFilterState {
  [key: string]: string;
}

export const CategoryCard = ({
  bordered,
  hoverable,
  imageUrl,
  category,
}: CategoryCardProps) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { scrollToTop } = useScroll();

  const coverImg = (
    <FallbackImage src={imageUrl || ''} type={'CategoryCard'} preview={false} />
  );

  const getFilterState = (category?: CategoryData) => {
    let state: CategoryFilterState = {};

    if (!category) return state;

    switch (category.level) {
      case 0:
        state['main-category'] = String(category.id);
        break;
      case 1:
        state['main-category'] = String(category.sub_id);
        state['sub-category'] = String(category.id);
        break;
      case 2:
        state['main-category'] = String(category.sub_sub_id);
        state['sub-category'] = String(category.sub_id);
        state['sub-subcategory'] = String(category.id);
        break;
      default:
        console.warn('Unknown category level:', category.level);
    }

    return state;
  };

  const handleClick = () => {
    if (!category?.id) return;
    const params = getFilterState(category);

    navigate(
      `${PublicRoute.PRODUCTS_ALL}?${new URLSearchParams(params).toString()}`
    );

    scrollToTop();
  };

  return (
    <StyledCategoryCard
      bordered={bordered}
      cover={coverImg}
      hoverable={hoverable}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className={'category-title'}>
        <p>{category?.name}</p>
      </div>
      <div className={'product-count'}>
        <p>
          {category?.product_count}{' '}
          {intl.formatMessage({ id: 'general.products' })}
        </p>
      </div>
    </StyledCategoryCard>
  );
};
